/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */

import { useTranslationStore } from '@/stores';
import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import {
  IEpAvatarDropdownUserMenuButtonsListInfos,
  IEpButtonGroupGeneral,
  IEpButtonGroupListData,
  IEpHeaderNavigationFormattedProductInfo,
  IEpHeaderNavigationProductInfo,
  IEpHeaderNavigationTranslations,
} from '../../interfaces';
import { IEpHeaderNavigationMenuData } from '../../interfaces/interfaces/components/IEpHeaderNavigation';
import { EpAvatar } from '../EpAvatar';
import { EpAvatarDropdownUserMenu } from '../EpAvatarDropdownUserMenu';
import { EpButton } from '../EpButton';
import { EpButtonCircle } from '../EpButtonCircle';
import { EpIcon } from '../EpIcon';
import { EpModal, showModal } from '../EpModal';
import { EpNavHighlight } from '../EpNavHighlight';
import { EpPopover } from '../EpPopover';
import EpProductNavigation from '../EpProductNavigation';
import './EpHeaderNavigation.scss';
import { EpimedLogoSVGCode } from './EpimedLogo';

interface EpHeaderNavigationProps {
  headerNavigationSystemTitle?: string;
  headerNavigationButtonId: string;
  headerNavigationProductsPopoverId: string;
  headerNavigationProductsHostPopoverId: string;
  headerNavigationHospitalLogoSrc?: string;
  userEmail: string;
  userName: string;
  userRole?: string;
  currentSystemLanguage: string;
  customClasses?: string;
  productsPopoverList: IEpHeaderNavigationProductInfo[];
  avatarUserMenuDropdownDefaultList: IEpAvatarDropdownUserMenuButtonsListInfos;
  translations: IEpHeaderNavigationTranslations;
  homeButtonId: string;
  homeButtonHref: string;
  prodigeButtonHref?: string;
  buttonVisionContent?: ReactNode;
  headerNavigationMenuData: IEpHeaderNavigationMenuData;
}

export const EpHeaderNavigation: React.FC<EpHeaderNavigationProps> = ({
  headerNavigationSystemTitle,
  headerNavigationButtonId,
  headerNavigationProductsPopoverId,
  headerNavigationProductsHostPopoverId,
  headerNavigationHospitalLogoSrc,
  userEmail,
  userName,
  userRole,
  currentSystemLanguage,
  customClasses,
  productsPopoverList,
  avatarUserMenuDropdownDefaultList,
  translations = {
    epimedSystems: '',
    epimedApps: '',
    cancel: '',
    learnMore: '',
    manageAccountButtonText: '',
    languageButtonText: '',
    supportButtonText: '',
    knowledgeBaseButtonText: '',
    exitBaseButtonText: '',
    prodigeTitle: '',
  },
  homeButtonId,
  homeButtonHref,
  prodigeButtonHref,
  buttonVisionContent,
  headerNavigationMenuData,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isMediumScreen, setIsMediumScreen] = useState<boolean>(
    window.innerWidth <= 780,
  );
  const [hamburgerMenuIsVisible, setHamburgerMenuIsVisible] =
    useState<boolean>(false);
  const [formattedNewProductsPopoverList, setFormattedNewProductsPopoverList] =
    useState<IEpHeaderNavigationFormattedProductInfo[]>([]);
  const [showSecondaryMenu, setShowSecondaryMenu] = useState<boolean>(false);
  const [secondaryMenuData, setSecondaryMenuData] = useState<
    IEpButtonGroupGeneral[]
  >([]);
  const [primaryMenuDropdownData, setPrimaryMenuDropdownData] = useState<any>(
    [],
  );
  const { loading: loadingTranslations } = useTranslationStore(
    (state) => state,
  );

  // const epHeaderNavigation = null;
  // const epProductNavigationPrimary = null;

  const epimedSystemsText = translations.epimedSystems;
  const epimedAppsText = translations.epimedApps;
  const cancelText = translations.cancel;
  const learnMoreText = translations.learnMore;
  const manageAccountButtonText = translations.manageAccountButtonText;
  const languageButtonText = translations.languageButtonText;
  const supportButtonText = translations.supportButtonText;
  const knowledgeBaseButtonText = translations.knowledgeBaseButtonText;
  const exitBaseButtonText = translations.exitBaseButtonText;

  const prodigeLogoSVGCode = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='24' viewBox='0 0 16 24' fill='none'%3E%3Crect y='12' width='8' height='8' fill='%23001945'/%3E%3Crect x='8' y='4' width='8' height='8' fill='%230091DA'/%3E%3Crect x='10.0043' y='14.0043' width='4.9913' height='4.9913' stroke='%23209FDF' stroke-width='2.0087'/%3E%3C/svg%3E`;

  const handleClickPrimaryMenu = (
    event: any,
    type: 'primary' | 'secondary' = 'primary',
  ) => {
    const { target } = event;

    if (
      (target.closest('.ep-dropdown__trigger-element') &&
        target.closest('.ep-dropdown')) ||
      type === 'secondary'
    )
      return;

    const targetIsDropdownItem = target.closest('.ep-dropdown');

    const targetIsALeftButton = target
      .closest('.ep-button')
      ?.closest('.ep-product-navigation__wrapper--left');

    if (targetIsDropdownItem) {
      setShowSecondaryMenu(true);
      handleSecondaryMenuData(targetIsDropdownItem);
    }

    if (!targetIsDropdownItem && targetIsALeftButton) {
      setShowSecondaryMenu(false);
    }
  };

  const handleSecondaryMenuData = useCallback(
    (dropdown?: HTMLElement) => {
      const someButtonIsInitiallyActive = primaryMenuDropdownData.some(
        ({
          buttonDropdownMenuListData,
          buttonIsActive,
        }: {
          buttonDropdownMenuListData: any;
          buttonIsActive: boolean;
        }) => buttonDropdownMenuListData && buttonIsActive,
      );

      if (dropdown) {
        const dropdownElId = dropdown.getAttribute('id');
        setSecondaryMenuData(
          primaryMenuDropdownData
            .filter(
              ({ dropdownId }: { dropdownId: string }) =>
                dropdownId === dropdownElId,
            )
            .flatMap(
              ({
                buttonDropdownMenuListData,
              }: {
                buttonDropdownMenuListData: any;
              }) => buttonDropdownMenuListData,
            ),
        );
        return;
      }

      if (someButtonIsInitiallyActive) {
        setSecondaryMenuData(
          primaryMenuDropdownData
            .filter(
              ({
                buttonDropdownMenuListData,
                buttonIsActive,
              }: {
                buttonDropdownMenuListData: any;
                buttonIsActive: boolean;
              }) => buttonDropdownMenuListData && buttonIsActive,
            )
            .flatMap(
              ({
                buttonDropdownMenuListData,
              }: {
                buttonDropdownMenuListData: any;
              }) => buttonDropdownMenuListData,
            ),
        );
        setShowSecondaryMenu(true);
      }
    },
    [primaryMenuDropdownData],
  );

  const handlePrimaryDropdownData = useCallback(
    (dropdownData: IEpButtonGroupListData[]) => {
      setPrimaryMenuDropdownData(dropdownData);
      handleSecondaryMenuData();
    },
    [handleSecondaryMenuData],
  );

  const getFormattedProductsPopoverListData = (
    productsList: IEpHeaderNavigationProductInfo[],
  ): IEpHeaderNavigationFormattedProductInfo[] => {
    let formattedList: IEpHeaderNavigationFormattedProductInfo[] = [];

    productsList.forEach((product: IEpHeaderNavigationProductInfo) => {
      const formattedProduct: IEpHeaderNavigationFormattedProductInfo = {
        id: product.id,
        displayOrder: product.displayOrder,
        navHighlightId: `header-navigation__popover-product--${product.id}`,
        navHighlightStatus: product.allowedForUser ? 'active' : 'disabled',
        productIconName: product.iconComponentName,
        productShortName: product.shortName || '--',
        productShortDescription: product.shortDescription || '--',
        productAccessUrl: product.accessUrl || '#',
        productLongDescription: product.longDescription || '--',
        productLongName: product.longName || '--',
        productMoreInfoUrl: product.moreInfoUrl || '#',
      };

      formattedList.push(formattedProduct);
    });

    formattedList = getOrderedProductsPopoverListData(formattedList);

    return formattedList;
  };

  const getOrderedProductsPopoverListData = (
    productsList: IEpHeaderNavigationFormattedProductInfo[],
  ) => {
    const contractedProductsList = productsList.filter(
      (product: IEpHeaderNavigationFormattedProductInfo) =>
        product.navHighlightStatus === 'active',
    );
    const uncontractedProductsList = productsList.filter(
      (product: IEpHeaderNavigationFormattedProductInfo) =>
        product.navHighlightStatus === 'disabled',
    );
    const orderedList = [
      ...contractedProductsList,
      ...uncontractedProductsList,
    ];

    return orderedList;
  };

  const changeProductsPopoverList = (
    newProductsPopoverList: IEpHeaderNavigationProductInfo[],
  ) => {
    if (
      newProductsPopoverList === null ||
      newProductsPopoverList === undefined ||
      newProductsPopoverList.length <= 0
    )
      return;

    setFormattedNewProductsPopoverList(
      getFormattedProductsPopoverListData(newProductsPopoverList),
    );
  };

  const ButtonHomeStructure = (): React.JSX.Element => (
    <EpButtonCircle
      buttonId={homeButtonId}
      buttonType="primary"
      buttonSize={isMediumScreen ? 'lg' : 'md'}
      buttonIconType={'icon'}
      buttonIconName="SolidHouseUser"
      customClasses="ep-header-navigation__home-button pd-0"
      buttonLinkHref={homeButtonHref}
      buttonLinkTarget="_self"
    ></EpButtonCircle>
  );

  const getUncontractedProductsModalsElementsStructure = (
    productsList: IEpHeaderNavigationFormattedProductInfo[],
  ) => {
    if (
      productsList === null ||
      productsList === undefined ||
      productsList.length <= 0
    )
      return '';

    return productsList.map((product) => {
      return (
        <EpModal
          key={`modal--product-not-contracted-${product.id}`}
          modalId={`modal--product-not-contracted-${product.id}`}
          modalTitle={epimedSystemsText}
          modalType="default"
          modalSize="md"
          modalButtonList={[
            {
              buttonId: `button--product-not-contracted-${product.id}-cancel`,
              buttonLeftIconName: 'SolidTimes',
              buttonSize: 'sm',
              buttonText: cancelText,
              isCloseButton: true,
              buttonType: 'secondary-outline',
            },
          ]}
        >
          <div className="ep-modal__content-body-title">
            <span className="ep-modal__content-body-title-icon">
              <EpIcon iconName={product.productIconName} iconSize={48} />
            </span>
            <h2 className="ep-modal__content-body-title-text">
              {product.productLongName}
            </h2>
          </div>
          <p className="ep-modal__content-body-long-desc">
            {product.productLongDescription}
          </p>
          <EpButton
            buttonId={`button--more-info-product-${product.id}`}
            buttonSize="sm"
            buttonText={learnMoreText}
            buttonType="primary-outline"
            buttonLinkHref={product.productMoreInfoUrl}
            buttonIsFullWidth
          />
        </EpModal>
      );
    });
  };

  const showUncontractedProdutModal = (productId: string): void => {
    showModal(`modal--product-not-contracted-${productId}`);
  };

  const showHamburgerMenu = (): void => {
    setHamburgerMenuIsVisible(true);
  };

  const hideHamburgerMenu = (): void => {
    setHamburgerMenuIsVisible(false);
  };

  const ButtonProdigeStructure = ({
    iconImgSrc,
    customClasses,
  }: {
    iconImgSrc: string;
    customClasses?: string;
  }) => {
    return (
      <EpButtonCircle
        buttonId="prodige-button--header-navigation"
        buttonType="secondary"
        buttonSize={isMediumScreen ? 'lg' : 'md'}
        buttonIconType="img"
        buttonIconImgSrc={iconImgSrc}
        buttonIconImgAlt=""
        buttonLinkHref={prodigeButtonHref}
        buttonLinkTarget="_blank"
        buttonIconSizeCustom={24}
        customClasses={customClasses}
      ></EpButtonCircle>
    );
  };

  useEffect(() => {
    changeProductsPopoverList(productsPopoverList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsPopoverList]);

  useEffect(() => {
    //  handleSecondaryMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryMenuDropdownData]);

  useEffect(() => {
    setShowSecondaryMenu(true);
  }, []);

  return (
    <div className={`navbar ep-header-navigation ${customClasses || ''}`}>
      <header className="ep-header-navigation__header-wrapper">
        {isMediumScreen && (
          <div className="ep-header-navigation__hamburger-menu hamburger-menu">
            {hamburgerMenuIsVisible ? (
              <div className="hamburger-menu__wrapper">
                <div className="hamburger-menu__header">
                  {<ButtonHomeStructure />}
                  <button
                    className="hamburger-menu__button hamburger-menu__button--close"
                    onClick={() => hideHamburgerMenu()}
                  >
                    <EpIcon iconName="SolidTimes" iconSize={20}></EpIcon>
                  </button>
                </div>
              </div>
            ) : (
              <button
                className="hamburger-menu__button hamburger-menu__button--trigger"
                onClick={() => showHamburgerMenu()}
              >
                <EpIcon iconName="SolidBars" iconSize={20}></EpIcon>
              </button>
            )}
          </div>
        )}

        <div className="ep-header-navigation__content ep-header-navigation__content--start">
          <EpimedLogoSVGCode />

          <div className="ep-header-navigation__icon-and-title">
            <div className="ep-header-navigation__icon-and-title-wrapper">
              <EpPopover
                popoverId={headerNavigationProductsPopoverId}
                popoverHostId={headerNavigationProductsHostPopoverId}
                popoverPlacement={`${
                  isMediumScreen ? 'bottom' : 'bottom-start'
                }`}
                popoverContentType="interactive-html"
                popoverEventType="hover"
                popoverTitle={epimedAppsText}
                selectorsToDismissPopover={['ep-nav-highlight']}
                customClasses="ep-header-navigation__popover"
                triggerPopover={
                  <EpButton
                    buttonId={headerNavigationButtonId}
                    buttonType="link-secondary"
                    buttonSize="lg"
                    buttonLeftIconName="SolidTh"
                    buttonIsFullHeight
                    customClasses="popover__trigger"
                    buttonOnClickFunc={() => console.log()}
                  />
                }
                popoverBodyContent={
                  <ul className="ep-header-navigation__nav-highlight-list">
                    {formattedNewProductsPopoverList &&
                      formattedNewProductsPopoverList.map(
                        (
                          product: IEpHeaderNavigationFormattedProductInfo,
                          index,
                        ): ReactNode => (
                          <li
                            key={index}
                            className="ep-header-navigation__nav-highlight-list-item"
                          >
                            <EpNavHighlight
                              navHighlightId={product.navHighlightId}
                              navHighlightSize="sm"
                              navHighlightTitle={product.productShortName}
                              navHighlightIconName={product.productIconName}
                              navHighlightStatus={product.navHighlightStatus}
                              {...(product.navHighlightStatus === 'active'
                                ? {
                                    navHighlightActiveHref:
                                      product.productAccessUrl,
                                    navHighlightActiveTarget: '_blank',
                                  }
                                : {
                                    navHighlightDisabledOnClickFunc: () =>
                                      showUncontractedProdutModal(
                                        `${product.id}`,
                                      ),
                                  })}
                            ></EpNavHighlight>
                          </li>
                        ),
                      )}
                  </ul>
                }
              ></EpPopover>

              <h1 className="ep-header-navigation__title">{`${headerNavigationSystemTitle} »`}</h1>

              {buttonVisionContent && buttonVisionContent}
            </div>
          </div>
        </div>

        <div className="ep-header-navigation__content ep-header-navigation__content--end">
          {!isMediumScreen && <ButtonHomeStructure />}
          {!isMediumScreen && prodigeButtonHref && (
            <EpPopover
              customClasses="prodige-popover"
              popoverId="prodige-popover--header-navigation"
              popoverHostId="prodige-host-popover--header-navigation"
              popoverContentType={'custom-html'}
              popoverEventType="hover"
              selectorsToDismissPopover={['ep-nav-highlight']}
              popoverPlacement={'bottom'}
              triggerPopover={
                <div className="popover__trigger">
                  <ButtonProdigeStructure
                    iconImgSrc={prodigeLogoSVGCode}
                    customClasses={'pd-0 prodige__height'}
                  />
                </div>
              }
              popoverBodyContent={
                <div
                  className="popover-body-content"
                  slot="popover-body-content"
                >
                  <EpAvatar
                    avatarId="prodige-popover__avatar--header-navigation"
                    avatarContent="icon"
                    avatarIconImgSrc={prodigeLogoSVGCode}
                    avatarIconImgAlt="Prodige Logo"
                    avatarSize="2xl"
                  />
                  <div
                    id="prodige-popover-body"
                    className="prodige-popover-body"
                  >
                    <h3 className="prodige-popover-body__title">
                      {translations.prodigeTitle}
                    </h3>
                    {translations.prodigeText}
                  </div>
                </div>
              }
            />
          )}

          {!loadingTranslations && (
            <EpAvatarDropdownUserMenu
              avatarDropdownUserMenuId="ep-header-navigation__avatar-dropdown--user-menu"
              userName={userName}
              userEmail={userEmail}
              {...(userRole && { userRole: userRole })}
              avatarId="ep-header-navigation__avatar--user-menu"
              dropdownMenuPlacement="end"
              dropdownId="ep-header-navigation__dropdown--user-menu"
              currentSystemLanguage={currentSystemLanguage}
              dropdownDefaultList={avatarUserMenuDropdownDefaultList}
              translations={{
                manageAccountButtonText: manageAccountButtonText,
                languageButtonText: languageButtonText,
                supportButtonText: supportButtonText,
                knowledgeBaseButtonText: knowledgeBaseButtonText,
                exitBaseButtonText: exitBaseButtonText,
              }}
            />
          )}

          {headerNavigationHospitalLogoSrc && (
            <img
              alt="Header navigation hospital logo"
              className="ep-header-navigation__logo"
              src={headerNavigationHospitalLogoSrc}
            />
          )}
        </div>
      </header>

      <div className="ep-header-navigation__modal-list--uncontracted-products">
        {getUncontractedProductsModalsElementsStructure(
          formattedNewProductsPopoverList,
        )}
      </div>

      {!loadingTranslations && (
        <div className="ep-header-navigation__product-navigation">
          <EpProductNavigation
            productNavigationId="ep-header-navigation__product-navigation--primary"
            productNavigationListData={headerNavigationMenuData.primaryMenu}
            productNavigationDrawerId="ep-product-navigation__drawer"
            productNavigationButtonGroupId="ep-product-navigation__button-group--primary"
            productNavigationButtonCircleId="ep-product-navigation__button-circle--primary"
            getButtonGroupWithDropdownData={handlePrimaryDropdownData}
            onClickFunc={handleClickPrimaryMenu}
          />

          {showSecondaryMenu && (
            <EpProductNavigation
              productNavigationId="ep-header-navigation__product-navigation--primary"
              productNavigationListData={headerNavigationMenuData.secondaryMenu}
              productNavigationDrawerId="ep-product-navigation__drawer"
              productNavigationButtonGroupId="ep-product-navigation__button-group--primary"
              productNavigationButtonCircleId="ep-product-navigation__button-circle--primary"
              getButtonGroupWithDropdownData={handlePrimaryDropdownData}
              onClickFunc={handleClickPrimaryMenu}
              productNavigationType="secondary"
            />
          )}
        </div>
      )}

      <div className="ep-header-navigation__modal-list--uncontracted-products"></div>
    </div>
  );
};
